export default "__VITE_ASSET__DnXDHIYY__"